// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Z5PSE","image":"Header_image__WsKdx","name":"Header_name__1NVsz","info":"Header_info__5IhYd","infoRow":"Header_infoRow__No-Lm"};